<script setup lang="ts">
import { inject, computed } from 'vue'
import type { InvestmentProject } from '@/server/api/buyer-front/types'
import { investmentProjectKey } from '@/symbols/listing'
import PdAmenitiesList from '@/components/pd/Amenities/List/index.vue'
import PdAmenitiesCarrousel from '@/components/pd/Amenities/Carrousel/index.vue'

const listing = inject(investmentProjectKey) as InvestmentProject
const categoriesInfo = listing.raw_listing.cms?.categories_info

const getAmenitiesFromCategories = (categoriesInfo:any) => {
  const amenities = categoriesInfo?.['plp-amenities'] ? JSON.parse(categoriesInfo['plp-amenities']) : []
  return amenities.length ? amenities : []
}

const amenitiesList = computed(() => {
  const amenities = getAmenitiesFromCategories(categoriesInfo)
  const list = amenities.map((amenitie: Record<string, any>): string[] => amenitie.attributes.title)
  return list.sort(Intl.Collator().compare)
})

const allAmenitiesHaveAttributes = (): boolean => {
  const amenities = getAmenitiesFromCategories(categoriesInfo)

  return amenities.every((amenity: Record<string, any>) => hasAllAttributes(amenity.attributes))
}

const displayAmenitiesCarrousel = computed(() => allAmenitiesHaveAttributes())

const hasAllAttributes = (attributes: Record<string, any>): boolean => {
  return attributes &&
    attributes.title &&
    attributes.image?.data?.attributes?.url
}

const amenitiesData = computed(() => {
  const amenities = getAmenitiesFromCategories(categoriesInfo)
  const amenityArray: Array<{ title: string, imageUrl: string }> = []
  amenities.forEach((amenitie: Record<string, any>) => {
    amenityArray.push({
      title: amenitie.attributes.title,
      imageUrl: amenitie.attributes.image.data?.attributes?.url
    })
  })
  return amenityArray
})

</script>

<script lang="ts">
export default {
  name: 'PdAmenities'
}
</script>

<template>
  <section v-if="amenitiesList.length">
    <PdAmenitiesCarrousel
      v-if="displayAmenitiesCarrousel"
      class="mt-32 md:mt-56"
      :amenities-data="amenitiesData" />

    <PdAmenitiesList
      v-else
      :amenities-list="amenitiesList" />
  </section>
</template>
